import React, { useState, useEffect } from 'react'
import styles from "./styles.module.css";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'

import { getUniversity } from '../../../actions/report';

import BtnBack from '../helper/btnBack/BtnBack';
import GetHeader from '../helper/getHeader/GetHeader';

import bg from '../../../assets/dashboard/background_1.png'
import logo_big from '../../../assets/dashboard/logo_big.png'
import Loader from 'react-loader';
import { BACKEND_URL_PREFIX } from '../../../utils/const';

const mainPPSList = [
  { label: 'военнослужащие', value: 'military' },
  { label: 'профессоров', value: 'professor' },
  { label: 'гражданский персонал', value: 'citizen' },
  { label: 'доцентов', value: 'docent' },
  { label: 'докторов наук', value: 'doctor' },
  { label: 'укомплектованность ппс учеными', value: 'staffing_scientists' },
  { label: 'кандидатов наук', value: 'candidate' }
]

const ppsAgeStatList = [
  { label: 'до 30 лет', value: 'lower_30' },
  { label: 'старше 60 лет', value: 'higher_60' },
  { label: 'от 51 до 60 лет', value: '51_60' },
  { label: 'от 41 до 50 лет', value: '41_50' },
  { label: 'от 31 до 40 лет', value: '31_40' },
]

const avgGiaMarkList = [
  { label: 'Государственный междисциплинарный экзамен', value: 'gos_interdisc_exam' },
  { label: 'Защита ВКР', value: 'vkr' },
  { label: 'Государственный экзамен по физической подготовке', value: 'gos_fiz' }
]

const militScientList = [
  { label: 'участие в предметных олимпиадах (количество курсантов)', value: 'cnt_invention_patent' },
  { label: 'участие в соревнованиях (количество курсантов)', value: 'cnt_patent_utility_models' },
  { label: 'участие в нир и окр (количество ппс)', value: 'nir_okr' },
  { label: 'количество рациональных предложений (за учебный год)', value: 'cnt_rational_proposals' },
  { label: 'количество программ для эвм и баз данных (за учебный год)', value: 'cnt_program_for_pc' }
]

const monthList = [
  { en: 'sep', ru: 'сен', num: 9 },
  { en: 'oct', ru: 'окт', num: 10 },
  { en: 'nov', ru: 'нов', num: 11 },
  { en: 'decb', ru: 'дек', num: 12 },
  { en: 'jan', ru: 'янв', num: 1 },
  { en: 'feb', ru: 'фев', num: 2 },
  { en: 'mar', ru: 'мар', num: 3 },
  { en: 'apr', ru: 'апр', num: 4 },
  { en: 'may', ru: 'май', num: 5 },
  { en: 'jun', ru: 'июн', num: 6 },
  { en: 'jul', ru: 'июл', num: 7 },
  { en: 'aug', ru: 'авг', num: 8 }
]


function FacultyStat({
  university,
  getUniversity,
  match
}) {

  const [uni, setUni] = useState(null);
  const [facultyList, setFacultyList] = useState(null);
  const [facult, setFacult] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const { id, facId, cathId } = match.params
  const { avg_gia_mark, main_pps_stat, mark_stat, military_scientific_work, pps_age_stat } = data || {}

  const fuckMode = !!parseInt(facId)

  const colors = ['red', 'blue', 'green', 'blueviolet', 'yellow'];

  const getSum = (data) => data?.reduce((accumulator, currentValue) => accumulator + currentValue.value, 0); //Получаем сумму баллов
  const getPers = (data, sum) => data?.map(el => `${el.value / (sum / 100)}`).sort((a, b) => a - b); //Получаем отсортированный список баллов в процентах

  const getValues = (data) => {
    const sum = getSum(data)
    const toPersList = getPers(data, sum);

    let start = toPersList && [`${colors[0]} 0% ${toPersList[0]}%`]; //Стартовый массив
    let persSumm = +toPersList[0]; //Сумма процентов
    const x = toPersList?.map((el, inx) => {
      if (inx > 0 && toPersList.length - 1 != inx) {
        persSumm = persSumm + +el;
        start.push(`${colors[inx]} ${toPersList[inx - 1]}% ${persSumm}%`)
      }

      if (toPersList.length - 1 == inx) {
        if (toPersList.length == 2) {
        }
        start.push(`${colors[inx]} ${persSumm}%`)
      }

    })

    return start;
  }

  const getConicGradient = (data) => {
    const x = `conic-gradient(${getValues(data)?.map(el => `${el}`)})`; //Формируем сonic-пradient css-стиль 
    return x;
  }

  useEffect(() => {
    !university?.length && getUniversity();
    setLoading(true)
  }, []);

  useEffect(() => {
    if (university && university.length > 0 && id != null && id != 'all') {
      const [one, two] = id.split('_');
      const univer = two ? university[one].branches[two] : university[one]
      const prefix = univer?.api_url
      if (prefix?.length > 1) {
        const url = `${prefix}faculty`
        fetch(url)
          .then(resp => resp.json())
          .then(data => setFacultyList(data))
      }
      setUni(univer)
    }

    if (id == 'all') {
      const url = `${BACKEND_URL_PREFIX}/faculty/cathedras`
      fetch(url)
        .then(resp => resp.json())
        .then(data => setFacultyList(data))
    }
  }, [university]);

  useEffect(() => {
    if (facultyList) {
      const facult = facultyList.find(({ idfaculty, idcathedra }) => fuckMode ? idfaculty == parseInt(facId) : (!idfaculty && idcathedra == cathId))
      if (facult) {
        const url = `${uni?.api_url ? uni?.api_url : `${BACKEND_URL_PREFIX}/`}dashboard/faculty_stat/${facId}/${cathId}`
        fetch(url)
          .then(resp => resp.json())
          .then(data => setResponseData(data))
      }
      setFacult(facult)
    }
  }, [facultyList])

  const setResponseData = (data) => {
    setData(data)
    setLoading(false)
  }

  const renderMainPPSStat = () => {

    const firstULlist = mainPPSList.filter((_, ind) => ind % 2 === 0)
    const secondULlist = mainPPSList.filter((_, ind) => ind % 2 === 1)

    const renderLi = ({ label, value }) => (
      <li>
        <span>{main_pps_stat[value]}%</span>
        {label}
      </li>
    )

    return (
      <div className={styles.firstMain}>
        <ul>{firstULlist.map(renderLi)}</ul>
        <ul>{secondULlist.map(renderLi)}</ul>
      </div>
    )
  }

  const renderPPSAgeStat = () => {
    // const goodList = ppsAgeStatList.map(({ value }) => ({ key: value, value: pps_age_stat[value] }))
    const mark = data.pps_age_stat

    const chartStyle = {
      backgroundImage: getConicGradient(mark),
      width: '250px',
      height: '250px'
    }
    return (
      <div className={styles.chartContainer}>
        <div className={styles.pieChart} style={chartStyle}></div>

        <div className={styles.pieLegenda}>
          {mark?.sort((a, b) => a.value - b.value).map((el, inx) => {
            const index = mark?.length - 1 - inx;
            // const legendLabel = ppsAgeStatList.find(item => item.value === el.key).label
            return (
              <div className={styles.entry}>
                <div className={styles.entryColor} style={{ background: `${colors[index]}` }}></div>
                <div className={styles.entryText} style={{ width: '400px' }}>
                  {el.age_group}
                  {/* <span>{mark[index].value}%</span> */}
                  <span>{el.percentage}%</span>
                </div>
              </div>
            )
          })}
        </div>

      </div>
    )
  }

  const getRusMonth = (month) => {
    return monthList.find(el => el.en == month.en)
  }

  const getRusMonth2 = (month) => {
    return monthList.find(el => el.num == month.value.month)
  }

  const renderMarkStat = () => {
    const ruMass = []
    Object.keys(mark_stat).forEach(function (key, index) {
      ruMass.push({ value: mark_stat[key], en: key });
    });
    return (
      <div className={styles.progressBlock}>
        <div className={styles.lineBLock}>
          {/* {[3.8, 4, 4.2, 4.4, 4.6, 4.8, 5].map(el => */}
          {[2, 2.5, 3, 3.5, 4, 4.5, 5].map(el =>

            <div className={styles.lineItem}>{el}
              <div className={styles.lineItemInner}></div>
            </div>)}
        </div>
        {ruMass?.map((el) =>
          <div className={styles.progress}>
            <div className={styles.score} style={{ height: `${(164 / 7) + (el.value.grade - 2) * (164 / 3.5)}px` }}><span></span></div>
            <div className={styles.month}>{getRusMonth2(el)?.ru}</div>
          </div>
        )
        }
      </div>
    )
  }

  const renderMilitaryScientificWork = () => {

    const renderLi = ({ label, value }) => (
      <li>
        <span>{military_scientific_work[value]}%</span>
        {label}
      </li>
    )

    return <ul>{militScientList.map(renderLi)}</ul>
  }

  const renderAvgGiaMark = () => {
    // const goodList = avgGiaMarkList.map(({ value }) => ({ key: value, value: avg_gia_mark[value] }))
    const mark = data.avg_gia_mark

    return (
      <div className={styles.avg_mark}>
        {mark &&
          <div className={styles.blocks}>
            <div className={styles.avg_markChartCylinderContainer}>
              {mark?.map((el, inx) => {
                const height = !!el.avg_grade ? `${130 / mark?.map(el => el.avg_grade).sort((a, b) => b - a)[0] * el.avg_grade}px` : '0px'
                return (
                  <div className={styles[`honors_degreeBlock_${inx}`]}>
                    <div className={styles.chartCylinder} style={{ height: height }}>
                      <div className={styles.perc}>{el.avg_grade}</div>
                    </div>
                    <span style={{ height: '80px' }}>{el.typename}</span>
                  </div>
                )
              })}
            </div>
          </div>
        }
      </div>
    )
  }

  return (
    <div className={styles.wrapper}>
      <img src={bg} className={styles.bg} />
      <div className={styles.logo_bigWrapper}>
        <img src={logo_big} className={styles.logo_big} />
      </div>
      <GetHeader title={<>СТАТИСТИКА ПО {fuckMode ? 'ФАКУЛЬТЕТУ' : 'КАФЕДРЕ'} <br /> {facult?.faculty || facult?.cathedra}</>} />

      <Loader loaded={!loading} color="grey">
        {
          data &&
          <div className={styles.wrapperBlock}>

            <div className={styles.first}>
              <h4 className={styles.title}>КАЧЕСТВЕННАЯ ХАРАКТЕРИСТИКА ППС</h4>
              {renderMainPPSStat()}
            </div>

            <div className={styles.second}>
              <h4 className={styles.title}>РАСПРЕДЕЛЕНИЕ ППС ПО ВОЗРАСТУ</h4>
              {renderPPSAgeStat()}
            </div>

            {fuckMode &&
              <div className={styles.third}>
              <h4 className={styles.title}>ДИНАМИКА УСПЕВАЕМОСТИ ЗА ТЕКУЩИЙ УЧЕБНЫЙ ГОД (СРЕДНИЙ БАЛЛ)</h4>
              {renderMarkStat()}
            </div>}

            {/* СКРЫЛ ТРЕТЬЮ 16\01  */}

            {/* <div className={styles.fourth}>
              <h4 className={styles.title}>ВОЕННО-НАУЧНАЯ РАБОТА</h4>
              {renderMilitaryScientificWork()}
            </div> */}

            {fuckMode &&
              <div className={styles.fifth}>
              <h4 className={styles.title}>СРЕДНИЙ БАЛЛ СДАЧИ ГОСУДАРСТВЕННЫХ АТТЕСТАЦИОННЫХ ИСПЫТАНИЙ ЗА УЧЕБНЫЙ ГОД</h4>
              {renderAvgGiaMark()}
            </div>}

          </div>
        }
      </Loader>

      <BtnBack />
    </div>
  )
}

const mapStateToProps = ({ report: { university } }) => ({ university });

export default connect(mapStateToProps, { getUniversity })(FacultyStat);